import { render, staticRenderFns } from "./StoreEditDeleteContrattoDiServizioTags.vue?vue&type=template&id=12128b86"
import script from "./StoreEditDeleteContrattoDiServizioTags.vue?vue&type=script&lang=js"
export * from "./StoreEditDeleteContrattoDiServizioTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports